import { useSelector } from 'react-redux';
import { useCallback } from 'react';

export const useExhibitorsTagCategories = (eventId) => {
    const selector = useCallback((state) => state.events[eventId]?.exhibitors.tags, [eventId]);
    return useSelector(selector) ?? [];
};
